import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[color:var(--ssm-border)] bg-white mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-display text-2xl mb-4">Simple Style Mode</div>
          <p className="text-sm text-neutral-600 max-w-sm leading-relaxed">
            Timeless essentials. Minimal design. Unbranded apparel designed
            in-house and shipped worldwide by ULTRANEQ LLC.
          </p>
          <form
            data-testid="newsletter-form"
            className="mt-8 flex items-center border-b border-neutral-300 max-w-sm"
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              type="email"
              placeholder="Your email address"
              data-testid="newsletter-email-input"
              className="flex-1 bg-transparent py-3 text-sm focus:outline-none"
            />
            <button
              type="submit"
              data-testid="newsletter-submit-btn"
              className="text-xs uppercase tracking-[0.2em] font-medium py-3"
            >
              Subscribe
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <div className="label-xs mb-4">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-link-shop" to="/shop" className="ssm-underline-link">All Products</Link></li>
            <li><Link to="/shop?category=t-shirts" className="ssm-underline-link">T-Shirts</Link></li>
            <li><Link to="/shop?category=hoodies" className="ssm-underline-link">Hoodies</Link></li>
            <li><Link to="/shop?category=sweatshirts" className="ssm-underline-link">Sweatshirts</Link></li>
            <li><Link to="/shop?category=jeans" className="ssm-underline-link">Jeans</Link></li>
            <li><Link to="/shop?category=shirts" className="ssm-underline-link">Shirts</Link></li>
            <li><Link to="/shop?category=sweaters" className="ssm-underline-link">Sweaters</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="label-xs mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-link-about" to="/about" className="ssm-underline-link">About</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="ssm-underline-link">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="label-xs mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-link-terms" to="/terms" className="ssm-underline-link">Terms &amp; Conditions</Link></li>
            <li><Link data-testid="footer-link-refund" to="/refund-policy" className="ssm-underline-link">Refund Policy</Link></li>
            <li><Link data-testid="footer-link-privacy" to="/privacy-policy" className="ssm-underline-link">Privacy Policy</Link></li>
            <li><Link data-testid="footer-link-legal" to="/legal-notice" className="ssm-underline-link">Legal Notice</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[color:var(--ssm-border)]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row gap-4 items-center justify-between">
          <div className="text-xs text-neutral-500">
            © {new Date().getFullYear()} ULTRANEQ LLC — Simple Style Mode. All rights reserved.
          </div>
          <div className="flex items-center gap-5 text-neutral-500">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="social-instagram"><Instagram size={16} /></a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter" data-testid="social-twitter"><Twitter size={16} /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="social-facebook"><Facebook size={16} /></a>
          </div>
          <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.2em] text-neutral-500">
            <span>Visa</span>
            <span>Mastercard</span>
            <span>Amex</span>
            <span>Stripe</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
